<div class="pt-not-found__body" [class.pt-not-found__body-hexagonal]="isHexagonalDesign">
  <img
    class="pt-not-found__symbol"
    [class.pt-not-found__symbol-hexagonal]="isHexagonalDesign"
    [src]="`assets/${folderName}404-${uiStore.isDarkTheme() ? 'white' : 'black'}.${extention}`"
    alt="not found"
  />
  <div class="pt-not-found__content">
    <p
      class="pt-not-found__title"
      [class.pt-not-found__title-hexagonal]="isHexagonalDesign"
      translate="notFoundPage.title"
    >
    </p>

    <p
      class="pt-not-found__description"
      translate="notFoundPage.description"
    >
    </p>

    @if (isHexagonalDesign) {
      <p
        class="pt-not-found__description"
        translate="notFoundPage.secondRow"
      >
      </p>
    }

    <a
      puButton
      uiType="secondary"
      class="pt-not-found__btn xl:pu-button_l"
      [routerLink]="'/'"
      size="l"
      translate="notFoundPage.backToHomePage"
    >
    </a>
  </div>
</div>
